<template>
  <div class="import-jobs">
    <div @click="openDialog()">
      <slot>
        <el-button
          size="small"
          style="width: 100%; margin-top: 28px; margin-bottom: 8px"
        >
          Привязка зон работ
        </el-button>
      </slot>
    </div>

    <el-dialog :title="`Привязка зон работ`" :visible.sync="dialogObject">
      <div class="add-jobs" v-if="dialogObject">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-table
          row-key="id"
          @select="handleSelectionChangeObject"
          @select-all="handleSelectionChangeObject"
          empty-text="Зоны не найдены"
          ref="multipleObjectTable"
          :data="filteredList"
          style="width: 100%"
        >
          <el-table-column
            property="check"
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="Объекты"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="create-footer">
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';

export default {
  name: 'PermissionZonesVersion',
  props: ['version'],
  data() {
    return {
      search: '',
      jobSearch: '',
      dialogObject: false,
      selectedZones: [],
      loading: false,
      availableZones: [],
      list: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  watch: {
    filteredList: _.debounce(function () {
      let version = this.version || {}

      this.filteredList.map((row) => {
        const availableZones = this.availableZones.map((a) => a.id);
        if (availableZones.includes(row.id) || (version.available_zones && version.available_zones.includes(row.id))) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
  },

  mounted() {
    this.fetchTree();
  },

  methods: {
    fire() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    openDialog() {
      let version = this.version || {}

      this.dialogObject = true;
      setTimeout(() => {
        this.list.map((row) => {
          if (version.available_zones && version.available_zones.includes(row.id)) {
            this.$refs.multipleObjectTable.toggleRowSelection(row);
            this.availableZones.push(row);
          }
        })
      }, 100);
    },
    handleSelectionChangeObject(selected) {
      this.selectedZones = selected;
      this.availableZones = this.list.filter((s) => {
        return this.selectedZones.find((l) => l.id === s.id)
      });
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('zones')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          {
            id: 'all',
            name: 'Корневой каталог',
            index: 0,
            isParent: true,
          },
          ..._.orderBy(getChildList(result), 'index', ['asc']),
        ];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;

      this.$emit('update', {
        ...this.version,
        available_zones: _.uniq(this.availableZones.map((o) => o.id))
      });

      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.selectedZones = [];
      this.search = '';
    },
  },
};
</script>

<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/PermissionZoneVersion.vue